function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.251 11.5738V6.09513C16.251 4.93919 15.3199 4 14.1738 4H5.07719C3.93115 4 3 4.93919 3 6.09513V11.5738C3 12.5852 3.71627 13.4521 4.68324 13.6328V15.5111C4.68324 15.7279 4.79068 15.9446 4.93393 16.0891C5.07719 16.2336 5.25625 16.3058 5.47113 16.3058C5.68602 16.3058 5.86508 16.2336 6.04415 16.0891L8.40785 13.705H14.2455C15.3199 13.705 16.251 12.7297 16.251 11.5738Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6108 11.4717H16.997V12.2917C16.997 13.5804 15.9373 14.6348 14.6422 14.6348H11.3926V16.9543C11.3926 17.7041 12.0048 18.3133 12.7584 18.3133H17.4679L19.0221 19.8597C19.1163 19.9534 19.2575 20.0003 19.3988 20.0003C19.5401 20.0003 19.6579 19.9534 19.752 19.8597C19.8462 19.766 19.9169 19.6254 19.9169 19.4848V18.2664C20.5291 18.1727 21.0001 17.6338 21.0001 16.9778V12.8306C21.0001 12.0809 20.3878 11.4717 19.6108 11.4717Z"
});

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.56b41b8c.svg";
export { ForwardRef as ReactComponent };